"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = YouTubePlayer;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _reactIntersectionObserver = require("react-intersection-observer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Player = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Player",
  class: "pl-p15cxdsq"
});
const View = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "View",
  class: "pl-vgqvs31"
});

/**
 * VideoLightbox component.
 * @module YouTubePlayer
 *
 * @param {Object} props React props
 * @param {string} props.youTubeId Video ID
 * @param {boolean} [props.autoPlay=false] ShowModal Boolean
 * @param {string} [props.loading='lazy'] Loading type
 * @param {string} props.dataCy Data-cy attribute
 * @returns {React.ReactElement} VideoLightbox component
 * @public
 */

function YouTubePlayer({
  youTubeId,
  autoPlay = false,
  loading = 'lazy',
  dataCy = 'youtube-player'
}) {
  const playerRef = (0, _react.useRef)(null);
  const {
    ref,
    inView
  } = (0, _reactIntersectionObserver.useInView)({
    triggerOnce: true,
    rootMargin: '100px 0px'
  });
  (0, _react.useEffect)(() => {
    const loadVideo = () => {
      const playerBox = playerRef.current;
      // eslint-disable-next-line no-unused-vars
      const player = new global.YT.Player(playerBox, {
        height: '360',
        width: '640',
        videoId: youTubeId,
        playerVars: {
          playsinline: 1
        },
        events: {
          onReady: e => autoPlay && e?.target?.playVideo()
        }
      });
    };
    if (inView || loading === 'eager') {
      const scriptID = 'yt-api';
      // Instantiate IFrame YouTube API
      const alreadyExists = document.getElementById(scriptID);
      if (alreadyExists) {
        global?.YT?.ready(loadVideo);
      } else {
        const apiScript = document.createElement('script');
        apiScript.id = scriptID;
        apiScript.src = '//www.youtube.com/iframe_api';
        apiScript.async = true;
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(apiScript, firstScriptTag);
        apiScript.onload = () => {
          global?.YT?.ready(loadVideo);
        };
      }
    }
  }, [inView, loading, autoPlay, youTubeId]);
  return /*#__PURE__*/_react.default.createElement(View, {
    ref: ref,
    "data-cy": dataCy
  }, /*#__PURE__*/_react.default.createElement(Player, {
    ref: playerRef
  }));
}
YouTubePlayer.propTypes = {
  youTubeId: _propTypes.default.string,
  autoPlay: _propTypes.default.bool,
  loading: _propTypes.default.oneOf(['lazy', 'eager']),
  dataCy: _propTypes.default.string
};